import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/landing/Hero';
import HeroSubline from '../components/landing/HeroSubline';
import Ecosystem from '../components/landing/Ecosystem';
import OurFacility from '../components/landing/OurFacility';
import DogWalking from '../components/landing/DogWalking';
import WagAndWine from '../components/landing/WagAndWine';
import Testimonials from '../components/landing/Testimonials';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash;
    const tryScroll = (attempt = 0) => {
      const el = document.querySelector(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else if (attempt < 10) {
        setTimeout(() => tryScroll(attempt + 1), 100);
      }
    };
    tryScroll();
  }, [location]);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <HeroSubline />
        <Ecosystem />
        <OurFacility />
        <DogWalking />
        <WagAndWine />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
